import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import ProspectingLayout from './ProspectingLayout';
import MarketMapPage from './pages/MarketMapPage';
import SalesWorklistPage from './pages/SalesWorklistPage';
import './prospecting-map.css';

/**
 * IMPORTANT:
 * ONE owns the top-level <Routes>. This module intentionally returns a <Route>
 * tree (not its own <Routes>) so it can be inserted into the application's
 * existing router exactly like the previous ProspectingModule.
 */
export default function ProspectingModule() {
  return (
    <Route path="/prospecting" element={<ProspectingLayout />}>
      <Route index element={<MarketMapPage />} />
      <Route path="mapa" element={<MarketMapPage />} />
      <Route path="lista" element={<SalesWorklistPage />} />

      {/* Backward-compatible redirects from the previous Prospecting workflow. */}
      <Route path="market" element={<Navigate to="/prospecting" replace />} />
      <Route path="moj-dzien" element={<Navigate to="/prospecting" replace />} />
      <Route path="analityka" element={<Navigate to="/prospecting" replace />} />
      <Route path="integracje" element={<Navigate to="/prospecting" replace />} />
      <Route path="*" element={<Navigate to="/prospecting" replace />} />
    </Route>
  );
}
